
import { useState } from "react";
import Menu from '../menu/Menu';
import OnlineSafety from "./OnlineSafety";



export default function OnlineSafetyScreen() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <OnlineSafety onOpenMenu={() => setIsMenuOpen(true)} />

      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-white">
          <Menu isLoggedIn={true} onClose={() => setIsMenuOpen(false)} />
        </div>
      )}
    </>
  );
}